import React, { Component } from 'react';
import { Configurations } from '../../Utils/Configurations';
import Geral from '../../Utils/Geral';
import moment from 'moment';
import ReactTable from 'react-table';
import { DateRangePicker } from 'react-dates';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import update from 'immutability-helper';
import axios from 'axios';
import { Collapse, Modal, ModalBody, ModalHeader } from "reactstrap";
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import "./Cile-Orders.scss";
import ModalFooter from 'reactstrap/lib/ModalFooter';
import Button from 'reactstrap/lib/Button';
import InputTag from '../../Components/Input-Tag/Input-Tag';
import NewAddress from '../../Components/New-Address/New-Address';


class CileOrdersList extends Component {
    constructor(props) {
        super(props);


        this.toggleFilters = this.toggleFilters.bind(this);
        this.filterSearch = this.filterSearch.bind(this);
        this.handleFocusChange = this.handleFocusChange.bind(this);
        this.handleDatesChange = this.handleDatesChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.getOrders = this.getOrders.bind(this);
        this.refreshTable = this.refreshTable.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.gerarListaPDF = this.gerarListaPDF.bind(this);
        this.gerarCartaoPresente = this.gerarCartaoPresente.bind(this);
        this.enviarPedidosFaturamento = this.enviarPedidosFaturamento.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.toggleModalFaturamento = this.toggleModalFaturamento.bind(this);
        this.toggleModalCriacaoPacotes = this.toggleModalCriacaoPacotes.bind(this);
        this.gerarListaRemessa = this.gerarListaRemessa.bind(this);
        this.toggleModalPedidosPlanilha = this.toggleModalPedidosPlanilha.bind(this);
        this.enviarPedidosPlanilha = this.enviarPedidosPlanilha.bind(this);
        this.changeAllCheckboxes = this.changeAllCheckboxes.bind(this);
        this.toggleModalRemessaSPDL = this.toggleModalRemessaSPDL.bind(this);
        this.validacaoDataColeta = this.validacaoDataColeta.bind(this);
        this.desabilitarInclusaoRemessaSPDL = this.desabilitarInclusaoRemessaSPDL.bind(this);
        this.toggleModalAlterarCodigoRastreio = this.toggleModalAlterarCodigoRastreio.bind(this);
        this.salvarCodigo = this.salvarCodigo.bind(this);
        this.atualizaPedidos = this.atualizaPedidos.bind(this);
        this.atualizaSolicitante = this.atualizaSolicitante.bind(this);
        this.rotinaRastreioCorreios = this.rotinaRastreioCorreios.bind(this);
        this.replaceAll = this.replaceAll.bind(this);
        this.onSelectFiles = this.onSelectFiles.bind(this);
        this.uploadXML = this.uploadXML.bind(this);
        this.toggleModalReturnXML = this.toggleModalReturnXML.bind(this);
        this.toggleModalListaPedidosSeparacao = this.toggleModalListaPedidosSeparacao.bind(this);
        this.listarPedidosSeparacao = this.listarPedidosSeparacao.bind(this);
        this.carregarRemessasDisponiveis = this.carregarRemessasDisponiveis.bind(this);
        this.statusSPDLOrder = this.statusSPDLOrder.bind(this);
        this.atualizarRemessa = this.atualizarRemessa.bind(this);
        this.getInfosTipoEnvio = this.getInfosTipoEnvio.bind(this);

        this.toggleModalFilialFaturamento = this.toggleModalFilialFaturamento.bind(this);

        this.criarPacotes = this.criarPacotes.bind(this);
        this.gerarEtiquetas = this.gerarEtiquetas.bind(this);
        this.desabilitaCriarPacotes = this.desabilitaCriarPacotes.bind(this);
        this.toggleModalGeracaoEtiquetas = this.toggleModalGeracaoEtiquetas.bind(this);

        this.gerarEtiquetasME = this.gerarEtiquetasME.bind(this);
        this.criarPacotesME = this.criarPacotesME.bind(this);

        this._orderFocusChange = this.handleFocusChange('order').bind(this);
        this._orderDatesChange = this.handleDatesChange('order').bind(this);
        this._paymentFocusChange = this.handleFocusChange('payment').bind(this);
        this._paymentDatesChange = this.handleDatesChange('payment').bind(this);
        this.trocaTransportadora = this.trocaTransportadora.bind(this);
        this.handleSelectChangeTransport = this.handleSelectChangeTransport.bind(this);
        this.salvarTrocaTransportadora = this.salvarTrocaTransportadora.bind(this);

        this.selecionaEnderecoDivergencia = this.selecionaEnderecoDivergencia.bind(this);
        this.escolherFilialReenvio = this.escolherFilialReenvio.bind(this);
        this.reenvioPedido = this.reenvioPedido.bind(this);

        this.abrirModalEndereco = this.abrirModalEndereco.bind(this);
        this.fecharModalEndereco = this.fecharModalEndereco.bind(this);
        this.permiteAlterarVinculoEndereco = this.permiteAlterarVinculoEndereco.bind(this);
        this.carregarEnderecosUsuario = this.carregarEnderecosUsuario.bind(this);
        this.selecionaEnderecoExistente = this.selecionaEnderecoExistente.bind(this);
        this.salvarNovoEnderecoPedido = this.salvarNovoEnderecoPedido.bind(this);
        this.atualizaVinculoEndereco = this.atualizaVinculoEndereco.bind(this);
        this.toggleModalNovoEnderecoPedido = this.toggleModalNovoEnderecoPedido.bind(this);

        this.Configurations = new Configurations();

        this.giftTypeOptions = [
            { label: "Com presente", value: 1 },
        ];

        this.dispatchTypeOptions = [
            { label: "Matriz", value: "001001001" },
            { label: "Filial", value: "001001002" }
        ];

        this.productTypeOptions = [
            { label: "Plano Diamante", value: 220 },
            { label: "Plano Esmeralda", value: 221 },
            { label: "Plano Ouro", value: 222 },
            { label: "Avulso", value: "avulso" },
            // { label: "Plano Digital Individual", value: 318 },
            // { label: "Plano Digital Duo", value: 319 },
            // { label: "Plano Digital Premium", value: 378 },
        ];

        this.logisticStatusOptions = [
            { label: "Pago", value: 4 },
            { label: "Enviada Protheus", value: 16 },
            { label: "Faturado", value: 11 },
            { label: "Pacote criado", value: 24 },
            { label: "Etiqueta Gerada", value: 15 },
            { label: "Enviado", value: 13 },
            { label: "Entregue", value: 14 },
            { label: "Cancelado", value: 2 },
            { label: "Suspenso", value: 17 },
            { label: "Recobrança Manual", value: 18 },
            { label: "Em transporte", value: 19 }
        ]

        this.shippingCompanyOptions = [
            { label: "Correios", value: 3 },
            { label: "Loggi", value: 14 },
            { label: "SPDL", value: 7 },
            { label: "JADLOG", value: 9 },
            { label: "CARGO", value: 10 },
            { label: "SEDEX - Melhor Envio", value: 11 },
            { label: "SEDEX - Correios", value: 12 },
            { label: "PAC - Melhor Envio", value: 13 },
        ]

        this.state = {
            openFilters: true,
            filters: {
                order: {
                    startDate: moment().subtract(60, 'days'),
                    endDate: moment(),
                },
                payment: {},
                logisticStatusList: [],
                paymentStatusList: [],
                productList: [],
                giftTypeList: [],
                shippingCompanyList: [],
                productTypeList: [],
                dispatchTypeList: [],
            },
            codMembroBusca: '',
            buscaRealizada: false,
            alertaBuscaMembro: false,
            isLoadingListaPDF: false,
            isLoadingPedidosFaturamento: false,
            isLoadingListaRemessa: false,
            modalFaturamento: false,
            modalCriacaoPacotes: false,
            modalGeracaoEtiquetas: false,
            hasError: false,
            errorMessage: '',
            modalPedidosPlanilha: false,
            listaPedidosPlanilha: [],
            listaPedidosErro: [],
            listaPedidosFaturados: [],
            listaPedidosReenvio: [],
            opcoesReenvio: {},
            textoReenvio: '',
            loadingReenvio: false,
            listaPacotesCriados: [],
            listaPacotesErro: [],
            listaEtiquetasGeradas: [],
            listaEtiquetasErro: [],
            modalRemessaSPDL: false,
            dataColeta: '',
            qtdMelhorEnvio: '',
            ordersList: [],
            dadosColetaValidos: true,
            isLoadingIncluirRemessaSPDL: false,
            flagSucessoInclusaoRemessa: false,
            modalAlterarCodigoRastreio: false,
            isLoadingCodigo: false,
            listaIdPedido: [],
            listaSolicitante: [],
            isLoadingCriarPacotes: false,
            isLoadingCriarPacotesBetalabs: false,
            opcoesTransportadora: false,
            novaTransportadora: null,
            arrayIndexEnderecoSelecionado: [],
            modalEndereco: false,
            selectedEndereco: null,
            selectedPedidoEndereco: null,
            enderecosUsuario: [],
            isLoadingEnderecosUsuario: false,
            modalNovoEnderecoPedido: false,
            isLoadingVinculoEndereco: false,
            mensagemVinculoEndereco: '',
            sucessoVinculoEndereco: null,
            idEnderecoSelecaoPendente: null
        }

        this._phrases = {
            closeDatePicker: "Fechar",
            clearDates: "Limpar datas",
            calendarLabel: "Calendário"
        }


        this.columns = [
            {
                Header: "",
                width: 30,
                className: 'text-center',
                Cell: row => {
                    return (
                        <span>{row.index + 1}</span>
                    )
                }
            },
            {
                Header: '',
                accessor: 'selecionaPedido',
                className: 'text-center pointer',
                width: 25,
                Cell: row => <i onClick={(e) => this.handleCheck2("selecionaPedido", row.index)} className={row.value ? `far fa-check-square fa-lg` : `far fa-square fa-lg`}></i>
            },
            {
                Header: 'Pedido',
                accessor: 'numeroPedido',
                className: 'text-center pointer',
                width: 70
            },

            {
                Header: 'ID Betalabs',
                accessor: 'idPedidoExterno',
                className: 'text-center pointer',
                width: 80,
                Cell: row => row.value || '-'
            },

            {
                Header: 'Solicitante',
                width: 220,
                className: 'pointer text-truncate text-center',
                accessor: 'nomeSolicitante',
            },
            {
                Header: 'Valor',
                accessor: 'valorPago',
                className: 'text-center pointer',
                width: 70,
                Cell: row => (<span>R$ {row.value !== undefined && row.value !== null ? row.value.toFixed(2).toString().replace('.', ',') : "0,00"}</span>)
            },
            {
                Header: 'Dt. pedido',
                accessor: 'dtPedido',
                className: 'pointer text-center',
                width: 70,
                Cell: row => (<span>{row.value !== undefined && row.value !== null ? moment(row.value).format('DD/MM/YY') : '-'}</span>)
            },
            {
                Header: 'Dt. pagto',
                accessor: 'dtPagto',
                className: 'pointer text-center',
                width: 70,
                Cell: row => (<span>{row.value !== undefined && row.value !== null ? moment(row.value).format('DD/MM/YY') : '-'}</span>)
            },
            {
                Header: 'Status',
                accessor: 'statusLogistica',
                className: 'text-center pointer',
                width: 100,
                Cell: row => !!row.value.nome ? <span className={`badge badge-${this.statusLogisticaBadgeType(row.value.id)}`}>{row.value.nome}</span> : <span></span>
            },
            {
                Header: 'Transp.',
                width: 140,
                className: 'pointer text-truncate text-center',
                accessor: 'idTransportadora',
                Cell: row => {
                    const _transp = this.shippingCompanyOptions.filter(item => item.value === row.value);
                    const nomeTransp = !!_transp && _transp.length > 0 ? _transp[0].label : '-'
                    return (
                        <span>{nomeTransp}</span>
                    )
                }
            },
            {
                Header: 'Tp. Envio',
                accessor: 'filial',
                className: 'text-center pointer',
                width: 65,
                Cell: row => !!row.value ? <span className={`badge badge-${this.getInfosTipoEnvio(row.value).badgeColor}`}>{this.getInfosTipoEnvio(row.value).text}</span> : <span></span>
            },
            {
                Header: 'Produto(s)',
                accessor: 'nomeProduto',
                className: 'text-center pointer produtos',
                width: 235,
                Cell: row => (
                    row.value.map((item, index) => {
                        return <p key={index} className="m-0">{item}</p>
                    })
                )
            },
            {
                Header: 'Presente',
                accessor: 'tipoCartao',
                className: 'text-center pointer',
                width: 65,
                Cell: row => !!row.value ? <span className='badge badge-orange'>cartão {row.value}</span> : <span></span>
            },
            {
                Header: 'Endereço',
                accessor: 'endereco',
                className: 'text-center pointer',
                width: 140,
                Cell: row => {
                    return (
                        <button
                            type="button"
                            className="btn btn-outline-primary btn-sm"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.abrirModalEndereco(row.original);
                            }}
                        >
                            Exibir endereço
                        </button>
                    )
                }
            },
            {
                Header: 'Rastreio',
                className: 'text-center pointer cod-rastreio',
                Cell: row => {
                    return (
                        <div className='row no-gutters'>
                            <div className='col-12'>
                                {row.original.idTransportadora === 3 && (
                                    <button className='btn btn-sm btn-outline-success' onClick={() => this.toggleModalAlterarCodigoRastreio(row.original.codRastreio, row.original.numeroPedido)}>{row.original.codRastreio !== null ? row.original.codRastreio : "Alterar"}</button>
                                )}
                                {!!row.original.codRastreioPacote && (
                                    <span>{row.original.codRastreioPacote}</span>
                                )}
                            </div>
                        </div>
                    )
                }
            },
        ]
    }

    handleInput(e) {
        e.preventDefault();
        const _name = e.target.name
        this.setState({ [_name]: e.target.value })
    }

    orderBadgeType(status) {
        switch (status.toLowerCase()) {
            case "pedido feito":
                return "primary";
            case "aguardando vigência":
                return "primary";
            case "vigência em andamento":
                return "primary";
            case "vencido":
                return "danger";
            case "pedido cancelado":
                return "danger";
            default:
                return "warning";
        }
    }

    getInfosTipoEnvio(filial) {
        let badgeColor, text;
        switch (filial) {
            case "001001001":
                badgeColor = "dark";
                text = "M001"
                break;
            case "001001002":
                badgeColor = "pink";
                text = "F002"
                break;

            default:
                break;
        }
        return { badgeColor, text }
    }

    paymentBadgeType(status) {
        switch (status.toLowerCase()) {
            case "pago":
                return "success";
            case "vencido":
                return "secondary";
            case "negado":
                return "danger";
            case "baixa manual":
                return "primary";
            default: // case 1, 3
                return "warning";
        }
    }

    deliveryBadgeType(status) {
        switch (status) {
            case "Entregue":
                return "primary";
            case "Não entregue":
                return "danger";
            default:
                return "danger";
        }
    }

    productBadgeType(status) {
        switch (status) {
            case "BS":
                return "primary";
            case "TC":
                return "danger";
            case "RD":
                return "warning";
            default:
                return "info";
        }
    }

    statusLogisticaBadgeType(idStatus) {
        switch (idStatus) {
            case 2:
                return "danger";
            case 4:
                return "success";
            case 11:
                return "warning";
            case 13:
                return "info";
            case 14:
                return "primary";
            case 15:
                return "orange";
            case 16:
                return "secondary";
            case 17:
                return "danger";
            case 18:
                return "secondary";
            case 19:
                return "purple";
            case 24:
                return "lightblue";
            default:
                return "secondary";
        }
    }


    handleSelectChange(e, o) {
        const _name = o.name;
        let _list = this.state.filters[_name];

        switch (o.action) {
            case "remove-value":
                const _index = _list.findIndex(item => item === o.removedValue);
                _list.splice(_index, 1);
                break;
            case "clear":
                const _filters = this.state.filters;
                _filters[_name] = [];
                this.setState({
                    filters: _filters
                });
                return o;
            default:
                _list.push(o.option);
                break;
        }

        const _filters = update(this.state.filters, { $merge: { [_name]: _list } });
        this.setState({ _filters });

        return o;
    }

    handleSelectChangeTransport = (selectedOption, meta) => {
        const { action } = meta;

        switch (action) {
            case "clear":
                this.setState({ novaTransportadora: null });
                break;

            case "select-option":
                this.setState({ novaTransportadora: selectedOption.value });
                break;

            default:
                break;
        }
    };

    toggleFilters() {
        this.setState({
            openFilters: !this.state.openFilters
        })
    }

    getOrders(o) {
        this.setState({ loading: true });

        const _params = [];

        if (!o.pageSize) {
            o.pageSize = 50;
            _params.push(`qtdItens=${o.pageSize}`);
        } else if (!(o.page + 1)) {
            o.page = 1;
            _params.push(`pagina=${o.page}`);
            o.sorted = []
            _params.push(`ordenacao=${o.sorted.map(item => item.id).join(',')}`);
        } else {
            _params.push(`qtdItens=${o.pageSize}`);
            _params.push(`pagina=${o.page + 1}`);
        }

        this.setState({
            pageSize: o.pageSize,
            page: o.page
        })

        if (this.state.filters.paymentStatusList.length > 0) {
            _params.push(`statusPgto=${this.state.filters.paymentStatusList.map(item => item.value).join(',')}`);
        }

        if (this.state.filters.productList.length > 0) {
            _params.push(`idsProdutos=${this.state.filters.productList.map(item => item.value).join(',')}`);
        }

        if (this.state.filters.productTypeList.length > 0) {
            _params.push(`idProdutoAssinatura=${this.state.filters.productTypeList.map(item => item.value).join(',')}`);
        }

        if (this.state.filters.logisticStatusList.length > 0) {
            _params.push(`idsStatusLogistica=${this.state.filters.logisticStatusList.map(item => item.value).join(',')}`);
        }


        if (this.state.filters.shippingCompanyList.length > 0) {
            _params.push(`idsTransportadora=${this.state.filters.shippingCompanyList.map(item => item.value).join(',')}`);
        }

        if (this.state.filters.dispatchTypeList.length > 0) {
            _params.push(`listaFilial=${this.state.filters.dispatchTypeList.map(item => item.value).join(',')}`);
        }

        if (this.state.filters.giftTypeList.length > 0) {
            _params.push(`presente=${this.state.filters.giftTypeList[0].value > 0}`);
        }

        if (!this.state.filters.payment.startDate && this.state.filters.payment.endDate) {
            _params.push(`dtInicioPgto=${moment(this.state.filters.payment.endDate).format("YYYY-MM-DD")}`);
            _params.push(`dtFimPgto=${moment(this.state.filters.payment.endDate).format("YYYY-MM-DD")}`);
        }

        if (this.state.filters.payment.startDate && !this.state.filters.payment.endDate) {
            _params.push(`dtInicioPgto=${moment(this.state.filters.payment.startDate).format("YYYY-MM-DD")}`);
            _params.push(`dtFimPgto=${moment(this.state.filters.payment.startDate).format("YYYY-MM-DD")}`);
        }

        if (this.state.filters.payment.startDate && this.state.filters.payment.endDate) {
            _params.push(`dtInicioPgto=${moment(this.state.filters.payment.startDate).format("YYYY-MM-DD")}`);
            _params.push(`dtFimPgto=${moment(this.state.filters.payment.endDate).format("YYYY-MM-DD")}`);
        }

        if (!this.state.filters.payment.startDate && this.state.filters.payment.endDate) {
            _params.push(`dtInicioPgto=${moment(this.state.filters.payment.endDate).format("YYYY-MM-DD")}`);
            _params.push(`dtFimPgto=${moment(this.state.filters.payment.endDate).format("YYYY-MM-DD")}`);
        }
        //////

        if (this.state.filters.order.startDate && !this.state.filters.order.endDate) {
            _params.push(`dtInicioCriacao=${moment(this.state.filters.order.startDate).format("YYYY-MM-DD")}`);
            _params.push(`dtFimCriacao=${moment(this.state.filters.order.startDate).format("YYYY-MM-DD")}`);
        }

        if (this.state.filters.order.startDate && this.state.filters.order.endDate) {
            _params.push(`dtInicioCriacao=${moment(this.state.filters.order.startDate).format("YYYY-MM-DD")}`);
            _params.push(`dtFimCriacao=${moment(this.state.filters.order.endDate).format("YYYY-MM-DD")}`);
        }

        if (this.state.filters.order.startDate && this.state.filters.order.endDate) {
            _params.push(`dtInicioCriacao=${moment(this.state.filters.order.startDate).format("YYYY-MM-DD")}`);
            _params.push(`dtFimCriacao=${moment(this.state.filters.order.endDate).format("YYYY-MM-DD")}`);
        }

        ////
        if (this.state.listaIdPedido.length > 0) {
            _params.push(`listaIdPedido=${this.state.listaIdPedido.join(',')}`);
        }

        if (this.state.listaSolicitante.length > 0) {
            _params.push(`solicitante=${this.state.listaSolicitante.join(',')}`);
        }

        const _orders = axios.get(this.Configurations.apiBasePath + `/cile/pedidos?${_params.join('&')}`);

        const _parametros = _params.join('&');

        _orders.then(response => {
            this.setState({
                ordersList: response.data.data.pedidos,
                pages: response.data.data.paginacao.totalPaginas,
                loading: false,
                parametros: _parametros,

            });
        }).catch(this.handleError);
    }

    refreshTable(o) {
        this.getOrders(o);
    }

    handleFocusChange(attr) {
        return function (focusedInput) {
            var dates = this.state.filters[attr];

            dates.focusedInput = focusedInput;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }

    handleDatesChange(attr) {
        return function ({ startDate, endDate }) {
            var dates = this.state.filters[attr];
            dates.startDate = startDate;
            dates.endDate = endDate;
            startDate ? dates.gte = startDate.format('YYYY[-]MM[-]DD') : delete dates.gte;
            endDate ? dates.lte = endDate.format('YYYY[-]MM[-]DD') : delete dates.lte;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }



    _outsideRange(day) {
        return day.format("YYYY-MM-DD") > moment().format("YYYY-MM-DD");
    }

    filterSearch(e) {
        e.preventDefault();
        this.getOrders({});
    }

    handleCheck(e, index) {
        this.setState({ ordersList: update(this.state.ordersList, { [index]: { [e.target.name]: { $set: !this.state.ordersList[index][e.target.name] } } }) })
    }

    handleCheck2(name, index) {
        this.setState({ ordersList: update(this.state.ordersList, { [index]: { [name]: { $set: !this.state.ordersList[index][name] } } }) })
    }

    gerarListaPDF() {
        this.setState({ isLoadingListaPDF: true })
        const listaPDFPedidosSelecionados = this.state.ordersList.filter(item => item.selecionaPedido).map(pedido => {
            return pedido.numeroPedido
        });

        const _body = {
            pedidos: listaPDFPedidosSelecionados
        }

        if (!!listaPDFPedidosSelecionados && listaPDFPedidosSelecionados.length > 0) {
            axios.post(this.Configurations.apiBasePathRemessa + `/logistica-cile/gerar-pdf-remessa`, _body)
                .then(response => {
                    if (!!response.data.remessa) {
                        this.setState({ sucessoGeracaoPDF: true });
                        Geral.downloadPDF(response.data.remessa, `coleta`);
                        this.changeAllCheckboxes(false);
                    }
                })
                .catch(this.handleError)
                .finally(() => {
                    this.setState({ isLoadingListaPDF: false })
                });
        }

    }

    trocaTransportadora() {
        this.setState({ opcoesTransportadora: !this.state.opcoesTransportadora })
    }

    salvarTrocaTransportadora() {
        this.setState({ loading: true })
        const pedidos = this.state.ordersList.filter(item => item.selecionaPedido)

        const _body = {
            'pedidos': pedidos.map((i) => i.numeroPedido),
            'idTransp': this.state.novaTransportadora
        }

        axios.post(this.Configurations.apiBasePath + `/logistica-cile/atualiza-transportadora`, _body)
            .then(() => {
                this.setState({
                    loading: false,
                    novaTransportadora: ''
                })
                this.getOrders({})
            })
            .catch(this.handleError)
    }

    gerarCartaoPresente() {
        this.setState({ isLoadingPDFCartaoPresente: true })
        const listaPDFPedidosSelecionados = this.state.ordersList.filter(item => item.selecionaPedido).map(pedido => {
            return pedido.numeroPedido
        });

        const _body = {
            pedidos: listaPDFPedidosSelecionados
        }

        if (!!listaPDFPedidosSelecionados && listaPDFPedidosSelecionados.length > 0) {
            axios.post(this.Configurations.apiBasePathRemessa + `/logistica-cile/gerar-cartao-presente`, _body)
                .then(response => {
                    if (!!response.data.cartaoPresente) {
                        this.setState({ sucessoGeracaoPDF: true });
                        Geral.downloadPDF(response.data.cartaoPresente, `cartao-presente`);
                        this.changeAllCheckboxes(false);
                    }
                })
                .catch(this.handleError)
                .finally(() => {
                    this.setState({ isLoadingPDFCartaoPresente: false })
                });
        }

    }

    gerarEtiquetas() {
        this.setState({ isLoadingEtiqueta: true })
        const listaPedidosSelecionados = this.state.ordersList.filter(item => item.selecionaPedido).map(pedido => {
            return pedido.numeroPedido
        });

        const _body = {
            arrayPedidos: listaPedidosSelecionados,
            responseType: "LABEL_RESPONSE_TYPE_BASE_64"
        }

        if (!!listaPedidosSelecionados && listaPedidosSelecionados.length > 0) {
            axios.post(this.Configurations.apiBasePath + `/v2/logistica-cile/loggi/imprimir-etiqueta`, _body)
                .then(response => {
                    if (!!response.data.etiqueta) {
                        Geral.downloadPDF(response.data.etiqueta, `etiqueta`);
                        this.setState({
                            listaEtiquetasGeradas: response.data.pedidosComPacote,
                            listaEtiquetasErro: response.data.pedidosSemPacote
                        }, () => this.toggleModalGeracaoEtiquetas())
                        this.changeAllCheckboxes(false);
                    }
                })
                .catch(this.handleError)
                .finally(() => {
                    this.setState({ isLoadingEtiqueta: false })
                });
        }

    }

    gerarEtiquetasME() {
        this.setState({ isLoadingEtiquetaME: true })
        const listaPedidosSelecionados = this.state.ordersList.filter(item => item.selecionaPedido).map(pedido => {
            return pedido.numeroPedido
        });

        const _body = {
            arrayPedidos: listaPedidosSelecionados
        }

        if (!!listaPedidosSelecionados && listaPedidosSelecionados.length > 0) {
            axios.post(this.Configurations.apiBasePath + `/logistica-cile/melhor-envio/imprimir-etiqueta`, _body)
                .then(response => {
                    if (!!response.data) {
                        // Geral.downloadPDF(response.data, `etiqueta`);
                        window.open(response.data.pdfUrl, "_blank");
                        this.setState({
                            listaEtiquetasGeradas: response.data.pedidosComPacote,
                            listaEtiquetasErro: response.data.pedidosSemPacote
                        }, () => this.toggleModalGeracaoEtiquetas())
                        this.changeAllCheckboxes(false);
                    }
                })
                .catch(this.handleError)
                .finally(() => {
                    this.setState({ isLoadingEtiquetaME: false })
                });
        }

    }

    enviarPedidosFaturamento(filial, reenvio, listaPedidosReenvio) {

        if (reenvio) {
            this.setState({ isLoadingReenvioPedidosFaturamento: true, isOpenModalFilialFaturamento: false })
            const _body = {
                pedidos: listaPedidosReenvio,
                filial: this.state.filialInicial
            };

            if (!!listaPedidosReenvio && listaPedidosReenvio.length > 0) {
                let listaAux = this.state.listaPedidosErro;

                for (let index = 0; index < listaPedidosReenvio.length; index++) {
                    const element = listaPedidosReenvio[index];
                    listaAux = listaAux.filter(item => item.idPedido !== element.idPedido)
                }

                this.setState({ listaPedidosErro: listaAux }, () => {
                    axios.post(this.Configurations.apiBasePath + `/logistica-cile/faturar-lote`, _body)
                        .then(response => {
                            const faturadosAtual = response.data.arrayFaturados.concat(this.state.listaPedidosFaturados),
                                errosAtual = response.data.arrayErros
                                    .concat(this.state.listaPedidosErro)
                                    .filter(item => !faturadosAtual.includes(item.idPedido))
                                ;

                            const reenvioAtual = response.data.arrayReenvio.concat(listaPedidosReenvio)
                            // console.log("🚀 ~ CileOrdersList ~ enviarPedidosFaturamento ~ errosAtual:", errosAtual)
                            // console.log("🚀 ~ CileOrdersList ~ enviarPedidosFaturamento ~ faturadosAtual:", faturadosAtual)
                            this.setState({
                                listaPedidosFaturados: faturadosAtual,
                                listaPedidosErro: errosAtual,
                                listaPedidosReenvio: reenvioAtual,
                                isLoadingReenvioPedidosFaturamento: false,
                                arrayIndexEnderecoSelecionado: []
                            });
                            // this.changeAllCheckboxes(false);
                            // this.toggleModalFaturamento();
                            this.reloadOrders();
                        }).catch(this.handleError)
                        .finally(() => this.setState({ isLoadingPedidosFaturamento: false }))
                })

            }

        } else {
            this.setState({ filialInicial: filial, isLoadingPedidosFaturamento: true, isOpenModalFilialFaturamento: false });
            const listaPedidosSelecionados = this.state.ordersList.filter(item => item.selecionaPedido).map(pedido => {
                return pedido.numeroPedido
            });

            const _body = {
                pedidos: listaPedidosSelecionados,
                filial
            };

            if (!!listaPedidosSelecionados && listaPedidosSelecionados.length > 0) {
                axios.post(this.Configurations.apiBasePath + `/logistica-cile/faturar-lote`, _body)
                    .then(response => {
                        this.setState({
                            listaPedidosFaturados: response.data.arrayFaturados,
                            listaPedidosErro: response.data.arrayErros,
                            listaPedidosReenvio: response.data.arrayReenvio,
                            isLoadingPedidosFaturamento: false,
                        });

                        this.changeAllCheckboxes(false);
                        this.toggleModalFaturamento();
                        this.reloadOrders();
                    }).catch(this.handleError)
                    .finally(() => this.setState({ isLoadingPedidosFaturamento: false }))
            }
        }

    }

    reenvioPedido(filial, reenvio, pedidoReenvio) {

        if (reenvio) {
            this.setState(prevState => ({
                opcoesReenvio: {
                    ...prevState.opcoesReenvio,
                    [pedidoReenvio]: { loading: true, mensagem: '', sucesso: null }
                }
            }));

            const _body = {
                pedido: pedidoReenvio,
                filial: filial
            };

            axios.post(this.Configurations.apiBasePath + `/logistica-cile/reenviar-faturamento`, _body)
                .then(response => {
                    this.setState(prevState => ({
                        opcoesReenvio: {
                            ...prevState.opcoesReenvio,
                            [pedidoReenvio]: { loading: false, mensagem: response.data.message, sucesso: true }
                        }
                    }));
                    this.reloadOrders();
                }).catch(err => {
                    this.setState(prevState => ({
                        opcoesReenvio: {
                            ...prevState.opcoesReenvio,
                            [pedidoReenvio]: { loading: false, mensagem: err.response.data.message, sucesso: false }
                        }
                    }));
                });
        }
    }

    gerarListaRemessa() {
        this.setState({ isLoadingListaRemessa: true })
    }

    criarPacotes() {
        this.setState({ isLoadingCriarPacotes: true })
        const listaPedidosSelecionados = this.state.ordersList.filter(item => item.selecionaPedido).map(pedido => {
            return pedido.numeroPedido
        });

        const _body = {
            arrayPedidos: listaPedidosSelecionados
        }

        if (!!listaPedidosSelecionados && listaPedidosSelecionados.length > 0) {
            axios.post(this.Configurations.apiBasePath + `/v2/logistica-cile/loggi/criar-lote-pacotes`, _body)
                .then(response => {
                    if (response.data.success) {
                        this.setState({
                            listaPacotesCriados: response.data.arrayPacotesGerados.map(item => item.idPedido),
                            listaPacotesErro: response.data.arrayErros,
                            isLoadingCriarPacotes: false,
                        });
                        this.toggleModalCriacaoPacotes();
                        this.changeAllCheckboxes(false);
                    }
                })
                .catch(this.handleError)
                .finally(() => {
                    this.setState({ isLoadingCriarPacotes: false })
                });
        }

    }

    criarPacotesME() {
        this.setState({ isLoadingCriarPacotesBetalabs: true })
        const listaPedidosSelecionados = this.state.ordersList.filter(item => item.selecionaPedido).map(pedido => {
            return pedido.numeroPedido
        });

        const _body = {
            arrayPedidos: listaPedidosSelecionados
        }

        if (!!listaPedidosSelecionados && listaPedidosSelecionados.length > 0) {
            axios.post(this.Configurations.apiBasePath + `/logistica-cile/melhor-envio/criar-lote`, _body)
                .then(response => {
                    if (response.data.success) {
                        this.setState({
                            listaPacotesCriados: response.data.arrayPacotesGerados.map(item => item.idPedido),
                            listaPacotesErro: response.data.arrayErros,
                            isLoadingCriarPacotes: false,
                        });
                        this.toggleModalCriacaoPacotes();
                        this.changeAllCheckboxes(false);
                    }
                })
                .catch(this.handleError)
                .finally(() => {
                    this.setState({ isLoadingCriarPacotes: false })
                });
        }

    }

    toggleModalFaturamento() {
        this.setState({ modalFaturamento: !this.state.modalFaturamento }, () => {
            if (!this.state.modalFaturamento) this.setState({
                listaPedidosErro: [],
                listaPedidosFaturados: [],
                filialInicial: undefined,
                arrayIndexEnderecoSelecionado: []
            })
        });
    }

    toggleModalCriacaoPacotes() {
        this.setState({ modalCriacaoPacotes: !this.state.modalCriacaoPacotes })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.msg || err.response.data.message : !!err.message ? err.message : 'Erro inesperado.' })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    toggleModalPedidosPlanilha() {
        this.setState({ modalPedidosPlanilha: !this.state.modalPedidosPlanilha })
    }

    enviarPedidosPlanilha() {
        const listaPedidosPlanilha = this.state.ordersList.filter(item => item.selecionaPedido).map(pedido => {
            return { numeroPedido: pedido.numeroPedido, nomeSolicitante: pedido.nomeSolicitante }
        });

        this.setState({
            listaPedidosPlanilha: listaPedidosPlanilha,

        })
        this.toggleModalPedidosPlanilha();

    }


    changeAllCheckboxes(value) {
        const novaListaSelecionados = this.state.ordersList.map(item => {
            return {
                ...item, selecionaPedido: value
            }
        })
        this.setState({ ordersList: novaListaSelecionados })
    }

    toggleModalRemessaSPDL() {
        this.setState({
            modalRemessaSPDL: !this.state.modalRemessaSPDL,
            flagSucessoInclusaoRemessa: false
        }, () => this.carregarRemessasDisponiveis())
    }
    validacaoDataColeta(dtColeta) {
        // First check for the pattern
        if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dtColeta))
            return false;

        // Parse the date parts to integers
        var parts = dtColeta.split("/");
        var day = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10);
        var year = parseInt(parts[2], 10);

        // Check the ranges of month and year
        if (year < 1000 || year > 3000 || month === 0 || month > 12)
            return false;

        var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        // Adjust for leap years
        if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
            monthLength[1] = 29;

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
    }

    replaceAll(string, search, replace) {
        return string.split(search).join(replace);
    }

    desabilitarInclusaoRemessaSPDL() {
        const listaPedidosSelecionados = this.state.ordersList.filter(item => item.selecionaPedido).map(pedido => {
            return pedido.numeroPedido
        })
        return listaPedidosSelecionados.length <= 0
    }

    toggleModalAlterarCodigoRastreio(codigo, numPedido) {
        this.setState({
            modalAlterarCodigoRastreio: !this.state.modalAlterarCodigoRastreio,
            codRastreioModal: codigo,
            pedidoRastreioModal: numPedido,
            flagSucessoCodigoRastreio: false
        })
    }

    salvarCodigo() {
        const _codigoValido = !!this.state.codRastreioModal && this.state.codRastreioModal.length > 3
        const _body = {
            idPedido: this.state.pedidoRastreioModal,
            // idPedido: 1234,
            codigoRastreio: this.state.codRastreioModal
        }
        if (_codigoValido) {
            this.setState({ isLoadingCodigo: true })
            axios.post(this.Configurations.apiBasePath + `/codigo-rastreio`, _body).then(response => {
                this.setState({
                    flagSucessoCodigoRastreio: response.data.success
                })
                this.reloadOrders();
            }).catch(this.handleError).finally(() => this.setState({ isLoadingCodigo: false }))
        }
    }

    reloadOrders() {
        const { pageSize, page } = this.state;
        const o = {
            pageSize, page
        }
        this.getOrders(o);
    }

    atualizaPedidos(_lista) {
        this.setState({ listaIdPedido: _lista })
    }

    atualizaSolicitante(_lista) {
        this.setState({ listaSolicitante: _lista })
    }

    rotinaRastreioCorreios() {
        this.setState({ isLoadingRotinaCorreios: true })
        axios.post(this.Configurations.apiBasePath + `/logistica-cile/rotina-rastreio`)
            .then(response => {
                this.reloadOrders();
            }).finally(() => this.setState({ isLoadingRotinaCorreios: false }))
    }

    onSelectFiles(e) {
        this.setState({ arrayFileUpload: e.target.files });
    }

    // TODO: substituir fluxo de upload de XML NF da área "Melhor Envio"
    // pelo fluxo de criar pacotes/gerar etiqueta similar à área da Loggi.
    async uploadXML() {
        this.setState({ isLoadingUploadXML: true })
        const formData = new FormData();
        for (let index = 0; index < this.state.arrayFileUpload.length; index++) {
            const element = this.state.arrayFileUpload[index];
            formData.append('arquivos', element);
        }
        await axios.post(this.Configurations.apiBasePath + `/logistica-cile/nf-xml`, formData, {
            headers: {
                "Content-Type": `multipart/form-data`,
            }
        })
            .then(response => {
                this.setState({
                    arrayReturnXML: response.data.arrayXMLs
                }, () => this.toggleModalReturnXML())
            })
            .catch(this.handleError)
            .finally(() => { this.setState({ isLoadingUploadXML: false }) });
    }

    toggleModalReturnXML() {
        this.setState({ modalReturnXML: !this.state.modalReturnXML })
    }

    toggleModalListaPedidosSeparacao() {
        this.setState({ modalListaPedidosSeparacao: !this.state.modalListaPedidosSeparacao })
    }

    listarPedidosSeparacao() {
        const listaPedidosSelecionados = this.state.ordersList.filter(item => item.selecionaPedido).map(pedido => {
            return pedido.numeroPedido
        });
        this.setState({
            listaPedidosSeparacao: listaPedidosSelecionados.join(";")
        }, this.toggleModalListaPedidosSeparacao());
    }

    carregarRemessasDisponiveis() {
        this.setState({ isLoadingRemessasDisponiveis: true })
        const _carriers = axios.get(this.Configurations.apiBasePath + `/logistica-cile/remessas/lista?pagina=1&qtdItens=5`);
        _carriers.then(response => {
            this.setState({
                listaRemessasDisponiveis: response.data.listaRemessas,
            })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingRemessasDisponiveis: false }))
    }

    atualizarRemessa(idRemessa) {
        const _index = this.state.listaRemessasDisponiveis.findIndex(item => item.idRemessa === idRemessa);
        this.setState({
            listaRemessasDisponiveis: update(this.state.listaRemessasDisponiveis, { [_index]: { loading: { $set: true } } }),
            idRemessaInclusao: null
        })
        const _body = {
            pedidos: this.state.ordersList.filter(item => item.selecionaPedido).map(pedido => {
                return pedido.numeroPedido
            })
        }
        axios.put(this.Configurations.apiBasePath + `/logistica-cile/remessas/atualizar/${idRemessa}`, _body).then(response => {
            this.setState({
                listaPedidosInclusaoRemessa: response.data.arraySuccess,
                listaPedidosErroRemessa: response.data.arrayError,
                flagSucessoInclusaoRemessa: true,
                idRemessaInclusao: idRemessa
            })
        }).catch(this.handleError).finally(() => this.setState({
            listaRemessasDisponiveis: update(this.state.listaRemessasDisponiveis, { [_index]: { loading: { $set: false } } })
        }))
    }

    statusSPDLOrder(id) {
        switch (id) {
            case 2:
                return "success";
            case 1:
                return "warning";
            default:
                return "warning";
        }
    }

    toggleModalFilialFaturamento() {
        this.setState({ isOpenModalFilialFaturamento: !this.state.isOpenModalFilialFaturamento })
    }

    toggleModalGeracaoEtiquetas() {
        this.setState({ modalGeracaoEtiquetas: !this.state.modalGeracaoEtiquetas })
    }

    abrirModalEndereco(pedido) {
        const statusLogisticaId = pedido.statusLogistica ? pedido.statusLogistica.id : undefined;

        this.setState({
            modalEndereco: true,
            selectedEndereco: pedido.endereco || null,
            selectedPedidoEndereco: {
                idPedido: pedido.numeroPedido,
                idSolicitante: pedido.idSolicitante,
                idEnderecoAtual: pedido.idEndereco,
                statusLogisticaId
            },
            enderecosUsuario: [],
            modalNovoEnderecoPedido: false,
            mensagemVinculoEndereco: '',
            sucessoVinculoEndereco: null,
            idEnderecoSelecaoPendente: null
        })

        if (this.permiteAlterarVinculoEndereco(statusLogisticaId) && pedido.idSolicitante) {
            this.carregarEnderecosUsuario(pedido.idSolicitante);
        }
    }

    fecharModalEndereco() {
        this.setState({
            modalEndereco: false,
            selectedEndereco: null,
            selectedPedidoEndereco: null,
            enderecosUsuario: [],
            modalNovoEnderecoPedido: false,
            mensagemVinculoEndereco: '',
            sucessoVinculoEndereco: null,
            idEnderecoSelecaoPendente: null
        })
    }

    permiteAlterarVinculoEndereco(idStatusLogistica) {
        return [4, 16].includes(idStatusLogistica);
    }

    carregarEnderecosUsuario(idUsuario) {
        this.setState({ isLoadingEnderecosUsuario: true })
        axios.get(this.Configurations.apiBasePath + `/enderecos/${idUsuario}`)
            .then(response => {
                this.setState({ enderecosUsuario: response.data.enderecos || [] })
            })
            .catch(this.handleError)
            .finally(() => this.setState({ isLoadingEnderecosUsuario: false }));
    }

    toggleModalNovoEnderecoPedido() {
        this.setState({
            modalNovoEnderecoPedido: !this.state.modalNovoEnderecoPedido,
            idEnderecoSelecaoPendente: null
        })
    }

    selecionaEnderecoExistente(endereco) {
        this.atualizaVinculoEndereco({ idEndereco: endereco.id }, {
            nome: endereco.titulo,
            uf: endereco.uf,
            cidade: endereco.cidade,
            bairro: endereco.bairro,
            cep: endereco.cep,
            logradouro: endereco.logradouro,
            numero: endereco.numero,
            complemento: endereco.complemento
        });
    }

    salvarNovoEnderecoPedido(_endereco) {
        this.atualizaVinculoEndereco({
            cep: _endereco.cep,
            uf: _endereco.uf,
            cidade: _endereco.cidade,
            bairro: _endereco.bairro,
            logradouro: _endereco.logradouro,
            numero: _endereco.numero,
            complemento: _endereco.complemento,
            nome: _endereco.titulo
        }, {
            nome: _endereco.titulo,
            uf: _endereco.uf,
            cidade: _endereco.cidade,
            bairro: _endereco.bairro,
            cep: _endereco.cep,
            logradouro: _endereco.logradouro,
            numero: _endereco.numero,
            complemento: _endereco.complemento
        });
    }

    atualizaVinculoEndereco(body, enderecoParaExibir) {
        if (!this.state.selectedPedidoEndereco) return;
        const { idPedido, idSolicitante } = this.state.selectedPedidoEndereco;

        this.setState({ isLoadingVinculoEndereco: true, mensagemVinculoEndereco: '', sucessoVinculoEndereco: null })

        axios.post(this.Configurations.apiBasePath + `/logistica-cile/pedido/${idPedido}/endereco`, body)
            .then(response => {
                this.setState(prevState => ({
                    mensagemVinculoEndereco: response.data.message,
                    sucessoVinculoEndereco: true,
                    selectedEndereco: enderecoParaExibir || prevState.selectedEndereco,
                    selectedPedidoEndereco: {
                        ...prevState.selectedPedidoEndereco,
                        idEnderecoAtual: response.data.idEndereco || (prevState.selectedPedidoEndereco || {}).idEnderecoAtual
                    },
                    modalNovoEnderecoPedido: false,
                    idEnderecoSelecaoPendente: null
                }));
                this.carregarEnderecosUsuario(idSolicitante);
                this.reloadOrders();
            })
            .catch(err => {
                this.setState({
                    mensagemVinculoEndereco: (err.response && err.response.data && err.response.data.message) || 'Não foi possível atualizar o vínculo de endereço.',
                    sucessoVinculoEndereco: false
                });
            })
            .finally(() => this.setState({ isLoadingVinculoEndereco: false }));
    }

    desabilitaCriarPacotes() {
        const nenhumPedido = this.state.ordersList.filter(item => item.selecionaPedido).length === 0;
        const pacoteJaCriado = this.state.ordersList.filter(item => item.selecionaPedido && (item.statusLogistica.id === 24)).length > 10;
        return nenhumPedido || pacoteJaCriado;
    }

    selecionaEnderecoDivergencia(infos, index) {
        // console.log("🚀 ~ CileOrdersList ~ selecionaEnderecoDivergencia ~ endereco:", infos)
        //validação obj endereco
        this.setState({
            isLoadingEnderecoDivergencia: true
        });

        let arrayAtualizado = this.state.arrayIndexEnderecoSelecionado;

        const _body = { ...infos.enderecos.cile, idUsuario: infos.idUsuario, idPedido: infos.idPedido };


        axios.post(this.Configurations.apiBasePath + "/logistica-cile/endereco-pedido/atualizar", _body).then(response => {
            arrayAtualizado.push({ posicao: index, idPedido: infos.idPedido });

            this.setState({
                arrayIndexEnderecoSelecionado: arrayAtualizado
                //atualizações do modal
            })
        }).catch(this.handleError).finally(() => {
            this.setState({
                isLoadingEnderecoDivergencia: false
            })
        })
    }

    escolherFilialReenvio(idPedido) {
        this.setState(prevState => {
            const opcoesReenvio = prevState.opcoesReenvio || {};
            const pedidoAtual = opcoesReenvio[idPedido] || {};
            const abertoAtual = pedidoAtual.aberto || false;

            return {
                opcoesReenvio: {
                    ...opcoesReenvio,
                    [idPedido]: {
                        ...pedidoAtual,
                        aberto: !abertoAtual
                    }
                }
            };
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const pedidosSelecionadosAntes = prevState.ordersList.filter(item => item.selecionaPedido).length;
        const pedidosSelecionadosAgora = this.state.ordersList.filter(item => item.selecionaPedido).length;

        if (pedidosSelecionadosAntes > 0 && pedidosSelecionadosAgora === 0) {
            if (this.state.opcoesTransportadora !== false) {
                this.setState({ opcoesTransportadora: false });
            }
        }
    }

    render() {
        const enderecoSelecionado = this.state.selectedEndereco || {};
        return (
            <div className="cile-orders-list">
                <div className="row">
                    <div className="col-10">
                        <h2 className="title-1">Cile - Pedidos</h2>
                    </div>
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header p-2" id="headingOne">
                                <div className="col-12">
                                    <button className="btn btn-link w-100 text-left" type="button" onClick={this.toggleFilters}>
                                        <i className={`fa mr-2 ${this.state.openFilters ? "fa-chevron-right" : "fa-chevron-down"}`}></i>
                                        Filtros
                                    </button>
                                </div>
                            </div>
                            <div className={`card-body ${!this.state.openFilters && "collapse"}`} id="boxFilters">
                                {this.state.loading ? (
                                    <div className="row no-gutters">
                                        <div className="col-12 text-center py-5">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    </div>
                                ) : (
                                    <form onSubmit={this.filterSearch} noValidate>
                                        <div className="row">
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="dpPayStartDate">Período de pagamento</label><br />
                                                    <DateRangePicker
                                                        showClearDates
                                                        enableOutsideDays
                                                        isOutsideRange={this._outsideRange}
                                                        startDate={this.state.filters.payment.startDate} // momentPropTypes.momentObj or null,
                                                        startDateId="dpPayStartDate" // PropTypes.string.isRequired,
                                                        endDate={this.state.filters.payment.endDate} // momentPropTypes.momentObj or null,
                                                        endDateId="dpPayEndDate" // PropTypes.string.isRequired,
                                                        onDatesChange={this._paymentDatesChange} // PropTypes.func.isRequired,
                                                        focusedInput={this.state.filters.payment.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                                        onFocusChange={this._paymentFocusChange} // PropTypes.func.isRequired,
                                                        displayFormat="DD/MM/YYYY"
                                                        startDatePlaceholderText="Data inicial"
                                                        endDatePlaceholderText="Data final"
                                                        phrases={this._phrases}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="dpPayStartDate">Período de criação</label><br />
                                                    <DateRangePicker
                                                        showClearDates
                                                        enableOutsideDays
                                                        isOutsideRange={this._outsideRange}
                                                        startDate={this.state.filters.order.startDate} // momentPropTypes.momentObj or null,
                                                        startDateId="dpOrderStartDate" // PropTypes.string.isRequired,
                                                        endDate={this.state.filters.order.endDate} // momentPropTypes.momentObj or null,
                                                        endDateId="dpOrderEndDate" // PropTypes.string.isRequired,
                                                        onDatesChange={this._orderDatesChange} // PropTypes.func.isRequired,
                                                        focusedInput={this.state.filters.order.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                                        onFocusChange={this._orderFocusChange} // PropTypes.func.isRequired,
                                                        displayFormat="DD/MM/YYYY"
                                                        startDatePlaceholderText="Data inicial"
                                                        endDatePlaceholderText="Data final"
                                                        phrases={this._phrases}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="ddlStatusLogistica">Status Logística</label>
                                                    <Select
                                                        id="ddlStatusLogistica"
                                                        placeholder="Selecione um status"
                                                        closeMenuOnSelect={true}
                                                        components={makeAnimated()}
                                                        defaultValue={this.state.filters.logisticStatusList}
                                                        isMulti
                                                        name="logisticStatusList"
                                                        onChange={this.handleSelectChange}
                                                        options={this.logisticStatusOptions}

                                                    />
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="ddlTransportadora">Transportadora</label>
                                                    <Select
                                                        id="ddlTransportadora"
                                                        placeholder="Selecione uma tranportadora"
                                                        closeMenuOnSelect={true}
                                                        components={makeAnimated()}
                                                        defaultValue={this.state.filters.shippingCompanyList}
                                                        isMulti
                                                        name="shippingCompanyList"
                                                        onChange={this.handleSelectChange}
                                                        options={this.shippingCompanyOptions}

                                                    />
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="ddlTipoProduto">Tipo de Produto</label>
                                                    <Select
                                                        id="ddlTipoProduto"
                                                        placeholder="Selecione um tipo de produto"
                                                        closeMenuOnSelect={true}
                                                        components={makeAnimated()}
                                                        defaultValue={this.state.filters.productTypeList}
                                                        isMulti
                                                        name="productTypeList"
                                                        onChange={this.handleSelectChange}
                                                        options={this.productTypeOptions}

                                                    />
                                                </div>
                                            </div>
                                            <div className="col-4 tags-pedido">
                                                <label>Busca por pedido</label>
                                                <InputTag atualizaTags={this.atualizaPedidos} tags={this.state.listaIdPedido} textInput={true} />
                                                <small>Insira o nº do(s) pedido(s) e pressione "Enter" ou "Tab".</small>
                                            </div>
                                            <div className="col-4 tags-pedido">
                                                <label>Nome do solicitante</label>
                                                <InputTag atualizaTags={this.atualizaSolicitante} tags={this.state.listaSolicitante} textInput={true} />
                                                <small>Insira o nome(s) do(s) solicitante(s) e pressione "Enter" ou "Tab".</small>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="ddlTipoEnvio">Tipo de Envio</label>
                                                    <Select
                                                        id="ddlTipoEnvio"
                                                        placeholder="Selecione um tipo de envio"
                                                        closeMenuOnSelect={true}
                                                        components={makeAnimated()}
                                                        defaultValue={this.state.filters.dispatchTypeList}
                                                        isMulti
                                                        name="dispatchTypeList"
                                                        onChange={this.handleSelectChange}
                                                        options={this.dispatchTypeOptions}

                                                    />
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="ddlPresente">Presente</label>
                                                    <Select
                                                        id="ddlPresente"
                                                        placeholder="Selecione uma opção"
                                                        closeMenuOnSelect={true}
                                                        components={makeAnimated()}
                                                        defaultValue={this.state.filters.giftTypeList}
                                                        isMulti
                                                        name="giftTypeList"
                                                        onChange={this.handleSelectChange}
                                                        options={this.giftTypeOptions}

                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 text-right">
                                                <button className="btn btn-primary">Buscar</button>
                                            </div>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row py-2'>
                    <div className='col-12 text-left'>
                        <div className='card bg-white rounded p-3 my-2 my-2'>
                            <div className='row no-gutters'>
                                <div className='col-2'>
                                    <span className='tema-hr'>Correios</span>
                                </div>
                                <div className='col-4 text-center'>
                                    {this.state.isLoadingRotinaCorreios ? (
                                        <div className="spinner-border text-primary text-center" role="status" />
                                    ) : (
                                        <button className='btn btn-outline-success' onClick={this.rotinaRastreioCorreios}>Atualizar Correios</button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 text-left'>
                        <div className='card bg-white rounded p-3 my-2'>
                            <div className='row no-gutters'>
                                <div className='col-2'>
                                    <span className='tema-hr'>Melhor Envio (Betalabs)</span>
                                </div>
                                <div className="col-8 text-center">
                                    {this.state.isLoadingUploadXML ? (
                                        <div className="spinner-border text-primary text-center" role="status" />
                                    ) : (
                                        <React.Fragment>
                                            {/* TODO: substituir este fluxo de upload XML NF pelo fluxo de criar pacotes/gerar etiqueta similar à área da Loggi */}
                                            <input type="file" accept=".xml" onChange={this.onSelectFiles} multiple />
                                            <button className="ml-3 btn btn-outline-secondary" disabled={!this.state.arrayFileUpload} onClick={this.uploadXML}>upload xml nf</button>
                                        </React.Fragment>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 text-left'>
                        <div className='card bg-white rounded p-3 my-2'>
                            <div className='row no-gutters'>
                                <div className='col-3'>
                                    <span className='tema-hr'>SPDL</span>
                                </div>
                                <div className='col-3 text-center'>
                                    <button className='btn btn-outline-secondary' disabled={this.desabilitarInclusaoRemessaSPDL()} onClick={this.toggleModalRemessaSPDL}>Adicionar à remessa SPDL</button>
                                </div>
                                <div className='col-3 text-center'>
                                    <button className='btn btn-outline-secondary' onClick={this.listarPedidosSeparacao}>lista pedidos</button>
                                </div>
                                <div className="col-3 text-right">
                                    <button className="btn btn-outline-secondary" onClick={this.enviarPedidosPlanilha}>Lista nominal</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 text-left'>
                        <div className='card bg-white rounded p-3 my-2'>
                            <div className='row no-gutters'>
                                <div className='col-2'>
                                    <span className='tema-hr'>Loggi</span>
                                </div>
                                <div className='col-2 text-center'>
                                    {this.state.isLoadingCriarPacotes ? (
                                        <div className="spinner-border text-primary text-center" role="status" />
                                    ) : (
                                        <button className='btn btn-outline-secondary' disabled={this.desabilitaCriarPacotes()} onClick={this.criarPacotes}>Criar pacotes</button>
                                    )}
                                </div>
                                <div className='col-2 text-center'>
                                    {this.state.isLoadingEtiqueta ? (
                                        <div className="spinner-border text-primary text-center" role="status" />
                                    ) : (
                                        <button className='btn btn-outline-secondary' disabled={this.state.ordersList.filter(item => item.selecionaPedido).length === 0} onClick={this.gerarEtiquetas}>Gerar etiqueta</button>
                                    )}
                                </div>
                                <div className='col-3 text-center'>
                                    <button className='btn btn-outline-secondary' onClick={this.listarPedidosSeparacao}>lista pedidos</button>
                                </div>
                                <div className="col-3 text-right">
                                    <button className="btn btn-outline-secondary" onClick={this.enviarPedidosPlanilha}>Lista nominal</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-12 text-left'>
                        <div className='card bg-white rounded p-3 my-2'>
                            <div className='row no-gutters'>
                                <div className='col-2'>
                                    <span className='tema-hr'>[APIs] Melhor Envio</span>
                                </div>
                                <div className='col-2 text-center'>
                                    {this.state.isLoadingCriarPacotesBetalabs ? (
                                        <div className="spinner-border text-primary text-center" role="status" />
                                    ) : (
                                        <button className='btn btn-outline-secondary' disabled={this.desabilitaCriarPacotes()} onClick={this.criarPacotesME}>Criar pacotes</button>
                                    )}
                                </div>
                                <div className='col-2 text-center'>
                                    {this.state.isLoadingEtiquetaME ? (
                                        <div className="spinner-border text-primary text-center" role="status" />
                                    ) : (
                                        <button className='btn btn-outline-secondary' disabled={this.state.ordersList.filter(item => item.selecionaPedido).length === 0} onClick={this.gerarEtiquetasME}>Gerar etiqueta</button>
                                    )}
                                </div>
                                <div className='col-3 text-center'>
                                    <button className='btn btn-outline-secondary' onClick={this.listarPedidosSeparacao}>lista pedidos</button>
                                </div>
                                <div className="col-3 text-right">
                                    <button className="btn btn-outline-secondary" onClick={this.enviarPedidosPlanilha}>Lista nominal</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-3 text-left mt-4'>
                        <button className='btn btn-sm btn-outline-secondary mr-1' id="checkAll" onClick={() => this.changeAllCheckboxes(true)}>Marcar todos</button>
                        <button className='btn btn-sm btn-outline-secondary ml-1' id="checkAll" onClick={() => this.changeAllCheckboxes(false)}>Desmarcar todos</button>
                    </div>
                    <div className='col-2 text-left mt-4 p-0'>
                        <button className="btn btn-outline-purple" disabled={this.state.ordersList.filter(item => item.selecionaPedido).length === 0} onClick={this.trocaTransportadora}>Trocar Transportadora</button>
                    </div>
                    <div className="col-2 text-left mt-4">
                        {this.state.isLoadingPDFCartaoPresente ? (
                            <div className="spinner-border text-primary text-center" role="status" />
                        ) : (
                            <button className="btn btn-outline-orange" disabled={this.state.ordersList.filter(item => item.selecionaPedido).length === 0} onClick={this.gerarCartaoPresente}>Gerar cartão presente</button>
                        )}
                    </div>
                    <div className="col-2 text-right mt-4">
                        {this.state.isLoadingListaPDF ? (
                            <div className="spinner-border text-primary text-center" role="status" />
                        ) : (
                            <button className="btn btn-outline-info" disabled={this.state.ordersList.filter(item => item.selecionaPedido).length === 0} onClick={this.gerarListaPDF}>Gerar PDF de remessa</button>
                        )}
                    </div>
                    <div className="col-3 text-center mt-4">
                        {this.state.isLoadingPedidosFaturamento ? (
                            <div className="spinner-border text-primary text-center" role="status" />
                        ) : (
                            <button className="btn btn-outline-primary" disabled={this.state.ordersList.filter(item => item.selecionaPedido).length === 0} onClick={this.toggleModalFilialFaturamento}>Enviar pedidos para faturamento</button>
                        )}
                    </div>
                </div>

                <Collapse isOpen={this.state.opcoesTransportadora && !(this.state.ordersList.filter(item => item.selecionaPedido).length === 0)}>
                    {this.state.opcoesTransportadora ?
                        <div className='row py-5'>
                            <div className='col-4 text-center'>
                                <h3>Selecionar nova transportadora:</h3>
                            </div>
                            <div className='col-4 text-center'>
                                <Select
                                    id="changeTransportadora"
                                    placeholder={'Selecione uma transportadora'}
                                    closeMenuOnSelect={true}
                                    components={makeAnimated()}
                                    // defaultValue={}
                                    name="shippingCompanyList"
                                    onChange={this.handleSelectChangeTransport}
                                    options={this.shippingCompanyOptions}
                                    isClearable
                                />
                            </div>
                            <div className='col-4 text-center'>
                                <button className="btn btn-outline-success" disabled={this.state.novaTransportadora === null} onClick={this.salvarTrocaTransportadora}>Selecionar</button>
                            </div>
                        </div>
                        : null}
                </Collapse>

                <div className="row mt-4">
                    <div className="col-12">
                        <div className="card tabela-pedidos-cile">
                            <div className="card-body p-0">
                                <ReactTable
                                    data={this.state.ordersList}
                                    columns={this.columns}
                                    onFetchData={this.refreshTable}
                                    defaultPageSize={50}
                                    pages={this.state.pages}
                                    manual
                                    loading={this.state.loading}
                                    className="-striped -highlight"
                                    headerClassName="ebs-table-header"
                                    previousText='Anterior'
                                    nextText='Próximo'
                                    loadingText='Carregando...'
                                    noDataText='Nenhum pedido encontrado.'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='linhas'
                                    pageSizeOptions={[5, 10, 25, 50, 100, 200, 300]}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <Modal size="lg" isOpen={this.state.modalFaturamento} toggle={this.toggleModalFaturamento}>
                    <ModalHeader toggle={this.toggleModalFaturamento}>Faturamento</ModalHeader>
                    <ModalBody>
                        <div className='row no-gutters modal-divergencia-endereco'>
                            <div className='col-8'>
                                <p>Pedidos enviados para faturamento: {this.state.listaPedidosFaturados.length}</p>
                            </div>
                            {this.state.arrayIndexEnderecoSelecionado.length > 0 && (
                                <div className='col-4'>
                                    {this.state.isLoadingReenvioPedidosFaturamento ? (
                                        <div className="spinner-border text-primary text-center" role="status" />

                                    ) : (
                                        <button onClick={() => this.enviarPedidosFaturamento(this.state.filialInicial, true, this.state.arrayIndexEnderecoSelecionado.map(item => item.idPedido).join(","))} className='btn btn-outline-primary'>reenviar para faturamento</button>
                                    )}
                                </div>
                            )}
                            <div className='col-12 border-top py-2' />
                            {(!!this.state.listaPedidosErro.filter(item => !!item.enderecos) && !!this.state.listaPedidosErro.filter(item => !!item.enderecos).length > 0) && (
                                <React.Fragment>
                                    <p>Pedidos com divergência de endereço: {this.state.listaPedidosErro.filter(item => !!item.enderecos).length}</p>
                                    {!!this.state.listaPedidosErro.filter(item => item.enderecos) && this.state.listaPedidosErro.filter(item => !!item.enderecos).length > 0 && (
                                        // <ul>
                                        <div className='col-12'>
                                            <div className='row'>
                                                {this.state.listaPedidosErro.filter(item => !!item.enderecos).map((item, index) =>
                                                    // <li key={index}>
                                                    //     <p className='m-0' >{item.mensagem}</p>
                                                    // {!!item.enderecos && !!item.enderecos.ebs && !!item.enderecos.cile && (
                                                    //     <React.Fragment>
                                                    //         <p className='m-0'>CILE: {item.enderecos.cile.cep} - {item.enderecos.cile.logradouro}, {item.enderecos.cile.numero} - {item.enderecos.cile.complemento} {item.enderecos.cile.bairro} - {item.enderecos.cile.cidade}/{item.enderecos.cile.uf}</p>
                                                    //         <p className='m-0'>EBS: {item.enderecos.ebs.cep} - {item.enderecos.ebs.logradouro}, {item.enderecos.ebs.numero} - {item.enderecos.ebs.complemento} {item.enderecos.ebs.bairro} - {item.enderecos.ebs.cidade}/{item.enderecos.ebs.uf}</p>
                                                    //     </React.Fragment>
                                                    // )}
                                                    // <p></p>
                                                    // </li>
                                                    <React.Fragment key={index}>
                                                        <div className='col-12'>
                                                            <b className='m-0' >{item.mensagem}</b>
                                                            {!!item.enderecos && !!item.enderecos.ebs && !!item.enderecos.cile && (
                                                                <React.Fragment>
                                                                    <div className='row no-gutters pb-1'>
                                                                        <div className='col-10'>
                                                                            {this.state.arrayIndexEnderecoSelecionado.filter(i => i.posicao === index).length > 0 ? (
                                                                                <React.Fragment>
                                                                                    <span className='badge badge-primary badge-endereco'>CILE: {item.enderecos.cile.cep} - {item.enderecos.cile.logradouro}, {item.enderecos.cile.numero} - {item.enderecos.cile.complemento} {item.enderecos.cile.bairro} - {item.enderecos.cile.cidade}/{item.enderecos.cile.uf}</span>
                                                                                    <i className="ml-2 fas fa-check text-primary"></i>
                                                                                </React.Fragment>
                                                                            ) : (
                                                                                <p className='m-0'>CILE: {item.enderecos.cile.cep} - {item.enderecos.cile.logradouro}, {item.enderecos.cile.numero} - {item.enderecos.cile.complemento} {item.enderecos.cile.bairro} - {item.enderecos.cile.cidade}/{item.enderecos.cile.uf}</p>
                                                                            )}

                                                                        </div>
                                                                        <div className='col-2'>
                                                                            {this.state.arrayIndexEnderecoSelecionado.filter(i => i.posicao === index).length <= 0 && (
                                                                                <>
                                                                                    <button onClick={() => this.selecionaEnderecoDivergencia(item, index)} className='btn btn-sm btn-outline-primary'>atualizar</button>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className='row no-gutters py-1'>
                                                                        <div className='col-10'>
                                                                            <p>EBS: {item.enderecos.ebs.cep} - {item.enderecos.ebs.logradouro}, {item.enderecos.ebs.numero} - {item.enderecos.ebs.complemento} {item.enderecos.ebs.bairro} - {item.enderecos.ebs.cidade}/{item.enderecos.ebs.uf}</p>
                                                                        </div>
                                                                    </div>
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    </React.Fragment>
                                                )}
                                                <div className='col-12 border-top py-2' />
                                            </div>
                                        </div>
                                        // </ul>
                                    )}
                                </React.Fragment>
                            )}
                            <div className='w-100'>
                                <p>Pedidos com erro no envio: {this.state.listaPedidosErro.filter(item => !item.enderecos).length}</p>
                            </div>
                            {this.state.listaPedidosErro && this.state.listaPedidosErro.map((item, index) => {
                                return (
                                    <div className='w-100 mb-2' key={index}>
                                        <p className='m-0'>{item.mensagem}</p>
                                    </div>
                                );
                            })}
                            <div className='col-12 border-top py-2 w-100' />
                            <div className='d-flex justify-content-between mb-3 w-100 align-items-center'>
                                <p className='m-0'>Pedidos para reenvio: {this.state.listaPedidosReenvio.length}</p>
                            </div>



                            <React.Fragment>
                                {this.state.listaPedidosReenvio && this.state.listaPedidosReenvio.map((item) => {
                                    const opcoes = (this.state.opcoesReenvio && this.state.opcoesReenvio[item.idPedido]) ? this.state.opcoesReenvio[item.idPedido] : { loading: false, mensagem: '', sucesso: null, aberto: false };
                                    return (
                                        <div className='row w-100 align-items-center border-top py-3' key={item.idPedido}>
                                            <div className='col-2'>
                                                <p className='mb-0'><strong>{item.idPedido}</strong></p>
                                            </div>
                                            {opcoes.loading ? (
                                                <div className='col-10 text-center' >
                                                    <div className='spinner-border text-primary text-center' />
                                                </div>
                                            ) : (
                                                <React.Fragment>
                                                    <div className='col-6'>
                                                        <p
                                                            className={
                                                                'mb-0 ' +
                                                                (!opcoes.mensagem
                                                                    ? 'text-dark'
                                                                    : opcoes.sucesso === true
                                                                        ? 'text-success'
                                                                        : opcoes.sucesso === false
                                                                            ? 'text-danger'
                                                                            : 'text-dark')
                                                            }
                                                        >
                                                            {opcoes.mensagem ? opcoes.mensagem : item.mensagem}
                                                        </p>

                                                    </div>
                                                    {opcoes.mensagem ?
                                                        opcoes.sucesso ?
                                                            <div className='col-4 d-flex'>
                                                                <i className="ml-2 fas fa-check text-success"></i>
                                                            </div>
                                                            :
                                                            <div className='col-4 d-flex'>
                                                                <i className="ml-2 text-danger">X</i>
                                                            </div>
                                                        :
                                                        opcoes.aberto ?
                                                            <div className='col-4 d-flex justify-content-between'>
                                                                <button disabled={this.state.isLoadingPedidosFaturamento} onClick={() => this.reenvioPedido("001001001", true, item.idPedido)} className='btn btn-dark'>Matriz</button>
                                                                <button disabled={this.state.isLoadingPedidosFaturamento} onClick={() => this.reenvioPedido("001001002", true, item.idPedido)} className='btn btn-pink'>Filial</button>
                                                            </div>
                                                            :
                                                            <div className='col-4 d-flex justify-content-center'>
                                                                <button className='btn btn-sm btn-outline-primary' onClick={() => this.escolherFilialReenvio(item.idPedido)}>Escolher filial</button>
                                                            </div>
                                                    }
                                                </React.Fragment>
                                            )}
                                        </div>
                                    )
                                })}
                            </React.Fragment>
                        </div>
                    </ModalBody>
                    {/* <ModalFooter>
                        <pre>{JSON.stringify(this.state.listaPedidosErro)}</pre>
                        <br />
                        <pre>{JSON.stringify(this.state.listaPedidosFaturados)}</pre>
                        <br />
                    </ModalFooter> */}
                </Modal>

                <Modal size="lg" isOpen={this.state.modalCriacaoPacotes} toggle={this.toggleModalCriacaoPacotes}>
                    <ModalHeader toggle={this.toggleModalCriacaoPacotes}>Criação de pacotes</ModalHeader>
                    <ModalBody>
                        <p>Pacotes criados: {this.state.listaPacotesCriados.length}</p>
                        <p>Pedidos com erro na criação: {this.state.listaPacotesErro.length}</p>
                        {!!this.state.listaPacotesErro && this.state.listaPacotesErro.length > 0 && (
                            <ul>
                                {this.state.listaPacotesErro.map((item, index) => <li key={index}>
                                    <p className='m-0' >{item.idPedido}: {item.message}</p>
                                </li>)}
                            </ul>
                        )}
                    </ModalBody>
                </Modal>

                <Modal size="lg" isOpen={this.state.modalGeracaoEtiquetas} toggle={this.toggleModalGeracaoEtiquetas}>
                    <ModalHeader toggle={this.toggleModalGeracaoEtiquetas}>Geração de etiquetas</ModalHeader>
                    <ModalBody>
                        <p>Etiquetas geradas: {this.state.listaEtiquetasGeradas.length}</p>
                        <p>Pedidos com erro na geração de etiqueta: {this.state.listaEtiquetasErro.length}</p>
                        {!!this.state.listaPacotesErro && this.state.listaEtiquetasErro.length > 0 && (
                            // <ul>
                            //     {this.state.listaEtiquetasErro.map((item, index) => <li key={index}>
                            //         <p className='m-0' >{item.idPedido}: {item.message}</p>
                            //     </li>)}
                            // </ul>
                            <ul>
                                {this.state.listaEtiquetasErro.map((item, index) => <li key={index}>
                                    <p className='m-0' >{item}</p>
                                </li>)}
                            </ul>
                        )}
                    </ModalBody>
                </Modal>

                <Modal size="md" isOpen={this.state.modalPedidosPlanilha} toggle={this.toggleModalPedidosPlanilha}>
                    <ModalHeader toggle={this.toggleModalPedidosPlanilha}>Pedidos</ModalHeader>
                    <ModalBody>
                        <table border="1">
                            <thead>
                                <tr>
                                    <th>idPedido</th>
                                    <th>Solicitante</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.listaPedidosPlanilha.map((item, index) => {
                                    return (
                                        <tr key={`linhaPedido-${index}`}>
                                            <td>{item.numeroPedido}</td>
                                            <td>{item.nomeSolicitante}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.modalRemessaSPDL} toggle={this.toggleModalRemessaSPDL}>
                    <ModalHeader toggle={this.toggleModalRemessaSPDL}>Remessas SPDL</ModalHeader>
                    <ModalBody>
                        {this.state.flagSucessoInclusaoRemessa ? (
                            <div className='row no-gutters'>
                                <div className='col-12 pt-3'>
                                    <strong>Remessa #{this.state.idRemessaInclusao}</strong>
                                    <p>Pedidos adicionados: {this.state.listaPedidosInclusaoRemessa.length}</p>
                                    <p>Pedidos não adicionados: {this.state.listaPedidosErroRemessa.length}</p>
                                    {!!this.state.listaPedidosErroRemessa && this.state.listaPedidosErroRemessa.length > 0 && (
                                        <ul>
                                            {this.state.listaPedidosErroRemessa.map((item, index) => <li key={index}>
                                                <p className='m-0' >{item}</p>
                                            </li>)}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className='row no-gutters'>
                                {this.state.isLoadingRemessasDisponiveis ? (
                                    <div className='col-12 text-center'>
                                        <div className="spinner-border text-primary text-center" role="status" />
                                    </div>
                                ) : (
                                    <div className='col-12'>
                                        {!this.state.listaRemessasDisponiveis || this.state.listaRemessasDisponiveis.length <= 0 ? (
                                            <div className='row'>
                                                <div className='col-12 text-center'>
                                                    <p>Não há remessas cadastradas.</p>
                                                </div>
                                            </div>


                                        ) : (
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <table border="1" className='w-100'>
                                                        <thead>
                                                            <tr>
                                                                <th width="10%" className='text-center'>#</th>
                                                                <th width="30%" className='text-center'>Dt. Coleta</th>
                                                                <th width="30%" className='text-center'>Envio</th>
                                                                <th width="30%" className='text-center'></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.listaRemessasDisponiveis.map((item, index) => {
                                                                return (
                                                                    <tr key={`linhaRemessa-${index}`}>
                                                                        <td width="10%" className='text-center py-2'>{item.idRemessa}</td>
                                                                        <td width="30%" className='text-center py-2'>{moment(item.dtColeta).format("DD/MM/YYYY")}</td>
                                                                        <td width="30%" className='text-center py-2'><span className={`badge badge-spdl badge-${this.statusSPDLOrder(item.idStatusRemessa)}`}>{item.statusRemessa}</span></td>
                                                                        {item.idStatusRemessa !== 2 && (
                                                                            <td width="30%" className='text-center py-2'>{this.state.listaRemessasDisponiveis[index].loading ? (
                                                                                <div className="spinner-border text-primary text-center" role="status" />
                                                                            ) : (<button onClick={() => this.atualizarRemessa(item.idRemessa)} className='btn btn-sm btn-outline-success'>selecionar</button>)}</td>
                                                                        )}
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </ModalBody>

                </Modal>
                <Modal isOpen={this.state.modalAlterarCodigoRastreio} toggle={this.toggleModalAlterarCodigoRastreio}>
                    <ModalHeader toggle={this.toggleModalAlterarCodigoRastreio}>Código de rastreio</ModalHeader>
                    <ModalBody>
                        <div className='row no-gutters'>
                            <div className='col-6 text-left'>
                                <label>Código (mínimo de 4 dígitos)</label>
                                <input name="codRastreioModal" type="text" className='form-control tex-left' onChange={this.handleInput} value={this.state.codRastreioModal} autoComplete={"off"} />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.flagSucessoCodigoRastreio && (
                            <div className='col-12 text-center text-success'>
                                <i>Alteração feita com sucesso!</i>
                            </div>
                        )}
                        <Button color='secondary' onClick={this.toggleModalAlterarCodigoRastreio}>Voltar</Button>
                        {this.state.isLoadingCodigo ? (
                            <div className="spinner-border text-primary text-center" role="status" />
                        ) : (
                            <Button color='success' onClick={this.salvarCodigo} disabled={!this.state.codRastreioModal}>Salvar</Button>
                        )}

                    </ModalFooter>
                </Modal>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                    goBack={!this.state.hasError}
                />
                {
                    !!this.state.arrayReturnXML && this.state.arrayReturnXML.length > 0 && (
                        <Modal isOpen={this.state.modalReturnXML} toggle={this.toggleModalReturnXML}>
                            <ModalHeader toggle={this.toggleModalReturnXML}>Melhor Envio - Importação NF</ModalHeader>
                            <ModalBody>
                                <p>Pedidos atualizados: {this.state.arrayReturnXML.length}</p>
                                {!!this.state.arrayReturnXML && this.state.arrayReturnXML.length > 0 && (
                                    <ul>
                                        {this.state.arrayReturnXML.map((item, index) => <li key={`item-${index}`}><small>{item.idPedido} - {item.NF.split("NFe")[1] || item.NF}</small></li>)}
                                    </ul>
                                )}
                            </ModalBody>
                        </Modal>
                    )
                }
                <Modal className='modal-pedidos-separacao' size="lg" isOpen={this.state.modalListaPedidosSeparacao} toggle={this.toggleModalListaPedidosSeparacao}>
                    <ModalHeader toggle={this.toggleModalListaPedidosSeparacao}>Lista de Pedidos</ModalHeader>
                    <ModalBody>
                        <p className='lista-pedidos-separacao'>{this.state.listaPedidosSeparacao}</p>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isOpenModalFilialFaturamento} toggle={this.toggleModalFilialFaturamento}>
                    <ModalHeader toggle={this.toggleModalFilialFaturamento}>Escolha de filial</ModalHeader>
                    <ModalBody>
                        <div className='row'>
                            <div className='col-12 d-flex justify-content-between'>
                                <button disabled={this.state.isLoadingPedidosFaturamento} onClick={() => this.enviarPedidosFaturamento(undefined)} className='btn btn-primary'>Regra de produtos</button>
                                <button disabled={this.state.isLoadingPedidosFaturamento} onClick={() => this.enviarPedidosFaturamento("001001001")} className='btn btn-dark'>Matriz</button>
                                <button disabled={this.state.isLoadingPedidosFaturamento} onClick={() => this.enviarPedidosFaturamento("001001002")} className='btn btn-pink'>Filial</button>
                            </div>
                        </div>


                    </ModalBody>
                </Modal>

                <Modal className="modal-lg" isOpen={this.state.modalEndereco} toggle={this.fecharModalEndereco}>
                    <ModalHeader toggle={this.fecharModalEndereco}>
                        Endereço do pedido
                    </ModalHeader>
                    <ModalBody>
                        <p className="mb-2"><strong>Nome:</strong> {enderecoSelecionado.nome || '-'}</p>
                        <p className="mb-2"><strong>Logradouro:</strong> {enderecoSelecionado.logradouro || '-'}</p>
                        <p className="mb-2"><strong>Número:</strong> {enderecoSelecionado.numero || '-'}</p>
                        <p className="mb-2"><strong>Complemento:</strong> {enderecoSelecionado.complemento || '-'}</p>
                        <p className="mb-2"><strong>Bairro:</strong> {enderecoSelecionado.bairro || '-'}</p>
                        <p className="mb-2"><strong>Cidade:</strong> {enderecoSelecionado.cidade || '-'}</p>
                        <p className="mb-2"><strong>UF:</strong> {enderecoSelecionado.uf || '-'}</p>
                        <p className="mb-0"><strong>CEP:</strong> {enderecoSelecionado.cep || '-'}</p>

                        <div className='col-12 border-top pt-3 mt-2 px-0'>
                            {this.permiteAlterarVinculoEndereco(this.state.selectedPedidoEndereco && this.state.selectedPedidoEndereco.statusLogisticaId) ? (
                                <React.Fragment>
                                    <h6>Alterar vínculo de endereço</h6>
                                    {this.state.isLoadingEnderecosUsuario ? (
                                        <div className="text-center py-2">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    ) : (
                                        <React.Fragment>
                                            {(() => {
                                                const idEnderecoAtual = this.state.selectedPedidoEndereco && this.state.selectedPedidoEndereco.idEnderecoAtual;
                                                const enderecosDisponiveis = this.state.enderecosUsuario.filter(end => end.id !== idEnderecoAtual);
                                                return enderecosDisponiveis.length > 0 && (
                                                    <div className='row no-gutters py-2'>
                                                        {enderecosDisponiveis.map((end, index) => {
                                                            const selecionado = this.state.idEnderecoSelecaoPendente === end.id;
                                                            return (
                                                                <div className='col-12 mb-2' key={`end-vinculo-${index}`}>
                                                                    <div className={`card p-2 ${selecionado ? 'border-primary' : ''}`}>
                                                                        <div className='row no-gutters align-items-center'>
                                                                            <div className='col-9'>
                                                                                <p className='m-0'>
                                                                                    <strong>{end.titulo}</strong>{end.principal ? ' (principal)' : ''}
                                                                                    {selecionado && (<i className="ml-2 fas fa-check text-primary"></i>)}
                                                                                </p>
                                                                                <small>{end.cep} - {end.logradouro}, {end.numero} {end.complemento} - {end.bairro} - {end.cidade}/{end.uf}</small>
                                                                            </div>
                                                                            <div className='col-3 text-right'>
                                                                                {selecionado ? (
                                                                                    <button className='btn btn-sm btn-outline-success' disabled={this.state.isLoadingVinculoEndereco} onClick={() => this.selecionaEnderecoExistente(end)}>confirmar</button>
                                                                                ) : (
                                                                                    <button className='btn btn-sm btn-outline-primary' disabled={this.state.isLoadingVinculoEndereco} onClick={() => this.setState({ idEnderecoSelecaoPendente: end.id })}>usar este</button>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                )
                                            })()}
                                            <div className='text-center py-2'>
                                                <button className='btn btn-outline-success btn-sm' onClick={this.toggleModalNovoEnderecoPedido}>
                                                    {this.state.modalNovoEnderecoPedido ? 'cancelar cadastro' : 'cadastrar novo endereço'}
                                                </button>
                                            </div>
                                            {this.state.modalNovoEnderecoPedido && (
                                                <NewAddress
                                                    salvarEndereco={this.salvarNovoEnderecoPedido}
                                                    isLoadingEndereco={this.state.isLoadingVinculoEndereco}
                                                />
                                            )}
                                            {this.state.mensagemVinculoEndereco && (
                                                <div className={`col-12 text-center py-2 ${this.state.sucessoVinculoEndereco ? 'text-success' : 'text-danger'}`}>
                                                    <small>{this.state.mensagemVinculoEndereco}</small>
                                                </div>
                                            )}
                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                            ) : (
                                <small className='text-muted'>Alteração de endereço disponível apenas para pedidos com status logística "Pago" ou "Enviada Protheus".</small>
                            )}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.fecharModalEndereco}>Fechar</Button>
                    </ModalFooter>
                </Modal>

            </div >
        )
    }

}

export default CileOrdersList;
